'use client';

import { useEffect } from 'react';
import { useFormState } from '@jucy-ui/forms';

export interface AnalyticsReporterProps {
    onErrors?: (message: string) => void;
}

export const AnalyticsReporter = ({ onErrors }: AnalyticsReporterProps) => {
    const { errors } = useFormState();
    const formErrors: string[] = [];
    for (const error of Object.values(errors)) {
        formErrors.push(error?.message as string);
    }

    const combinedErrorMessage = formErrors.join('|');
    useEffect(() => {
        if (combinedErrorMessage && onErrors) {
            onErrors(combinedErrorMessage);
        }
    }, [combinedErrorMessage, onErrors]);

    return null;
};

AnalyticsReporter.displayName = 'AnalyticsReporter';
